import TextField from "@mui/material/TextField"
import Autocomplete from "@mui/material/Autocomplete"
import { PostAdminContext } from "./Posts"
import { useContext } from "react"

const PostIdFilter = ({ maxWidth }) => {
	const postAdminContext = useContext(PostAdminContext)
	const handleIdFilter = postAdminContext.handleIdFilter
	const posts = postAdminContext.posts

	return (
		<Autocomplete
			disablePortal
			options={posts.map((post) => ({
				label: post.id,
				id: post.id,
			}))}
			renderInput={(params) => <TextField {...params} label="מזהה" />}
			size="small"
			sx={{ width: "100%", pb: 2, pt: 1, maxWidth: maxWidth ?? "auto" }}
			onChange={(event, newValue) => {
				handleIdFilter(newValue)
			}}
			isOptionEqualToValue={(option, value) => option.id === value.id}
		/>
	)
}

export default PostIdFilter
